var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticStyle: { "font-size": "14px", "margin-bottom": "10px" } },
      [
        _c("i", { staticClass: "fa-regular fa-clock" }),
        _vm._v("  \n    "),
        Object.keys(_vm.parsedAvailableReturnDates).length === 0
          ? _c("strong", [_vm._v("SELECIONE A DATA")])
          : _c("strong", [_vm._v("SELECIONE O PERÍODO")]),
      ]
    ),
    _vm._v(" "),
    _vm.formatedDateList.length > 0
      ? _c("div", { staticClass: "container-selection" }, [
          _c(
            "div",
            {
              staticClass: "pagination-control",
              class: { invisible: !_vm.hasPreviousPage },
              on: { click: _vm.previousPage },
            },
            [_c("i", { staticClass: "fas fa-chevron-left" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "container-dates" },
            _vm._l(_vm.formatedDateList, function (data, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "item",
                  style: {
                    "background-color":
                      _vm.dateToBRString(_vm.value) == _vm.dateToBRString(data)
                        ? _vm.primaryColor
                        : "white",
                    color:
                      _vm.dateToBRString(_vm.value) == _vm.dateToBRString(data)
                        ? "white"
                        : "#2A2A2A",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.selectDate(data)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.formatItem(data)) + "\n      "
                  ),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.loadingMore
            ? _c(
                "div",
                {
                  staticClass: "pagination-control",
                  staticStyle: { cursor: "default" },
                  on: { click: _vm.nextPage },
                },
                [
                  _c("i", {
                    staticClass: "far fa-hourglass",
                    staticStyle: { color: "gray", "font-size": "30px" },
                  }),
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "pagination-control",
                  class: { invisible: !_vm.hasNextPage },
                  on: { click: _vm.nextPage },
                },
                [_c("i", { staticClass: "fas fa-chevron-right" })]
              ),
        ])
      : _c("div", { staticStyle: { "text-align": "center" } }, [
          _c("i", [_vm._v("Nenhuma data disponível")]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }